import { Page } from "../../Page"
import { useEffect } from 'react';
import { resetButtons, setBackButtonVisible, setHomeButtonVisible, setReloadButtonVisible } from '../menu/menuSlice'
import {  useAppDispatch } from '../../app/hooks';
import styles from './privacy.module.css'
import { BackButton } from "../menu/BackButton";

export function Privacy() {
	const dispatch = useAppDispatch()
	useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
		dispatch(setHomeButtonVisible(true))
		dispatch(setReloadButtonVisible(true))
      }, [dispatch]);
    return (
        <Page>
			<div className={styles.bannerContainer}>
              <div>
                  <h2>PartyPlanner.</h2>
                     <h4>Organise, invite and celebrate in style.</h4>
              </div>
              <div className={styles.bannerButton}>
                  <BackButton/>
              </div>
            </div>
			<div className={styles.content}>
            	<h1>Privacy Policy</h1>
					<p>Type of website: Event organisation</p>
					<p>Effective date: 1st day of July, 2024</p>
					<p>parytplanner.abs.uk.com (the "Site") is owned and operated by Adaptive Business Solutions Limited. Adaptive Business Solutions Limited is the data controller and can be contacted at:</p>
					<p>customer-services@abs.uk.com</p>
					<p>02476 939914</p>
					<p>Unit 6, Centenary Business Centre, Nuneaton, CV11 6RY</p>
	      		<h2>Purpose</h2>
          			<p>The purpose of this privacy policy (this "Privacy Policy") is to inform users of our Site of the following: </p>
          
		 <div>
		 	<li value="1"><span>The personal data we will collect;</span></li>
			<li value="2"><span>Use of collected data;</span></li>
	 		<li value="3"><span>Who has access to the data collected; </span></li>
		 	<li value="4"><span>The rights of Site users.</span></li>
		</div>
	 <p>This Privacy Policy applies in addition to the terms and conditions of our Site.</p>
	 <h2>GDPR</h2>
	 <p>For users in the European Union, we adhere to the Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016, known as the General Data Protection Regulation (the "GDPR"). For users in the United Kingdom, we adhere to the GDPR as enshrined in the Data Protection Act 2018.</p>
	 <h2>Consent</h2>
	 <p>By using our Site users agree that they consent to:</p>
	 <div>
	 	<li value="1"><span>The conditions set out in this Privacy Policy.</span></li>
	 </div>
	 <p>When the legal basis for us processing your personal data is that you have provided your consent to that processing, you may withdraw your consent at any time. If you withdraw your consent, it will not make processing which we completed before you withdrew your consent unlawful.</p>
	 <p>You can withdraw your consent by: Contact site owner via email.</p>
	 <h2>Legal Basis for Processing</h2>
	 <p>We collect and process personal data about users in the EU only when we have a legal basis for doing so under Article 6 of the GDPR. We rely on the following legal basis to collect and process the personal data of users in the EU:</p>
	 <div>
	 	<li value="1"><span>Users have provided their consent to the processing of their data for one or more specific purposes.</span></li>
	 </div>
	 <br></br>
	 <h2>Personal Data We Collect</h2>
	 <p>We only collect data that helps us achieve the purpose set out in this Privacy Policy. We will not collect any additional data beyond the data listed below without notifying you first.</p>
	 <h3>Data Collected Automatically</h3>
	 <p>When you visit and use our Site, we may automatically collect and store the following information:</p>
	 <div>
	 	<li value="1"><span>Email address.</span></li>
	 </div>
	 <br></br>
	 <h2>How We Use Personal Data</h2>
	 <p>Data collected on our Site will only be used for the purposes specified in this Privacy Policy or indicated on the relevant pages of our Site. We will not use your data beyond what we disclose in this Privacy Policy.The data we collect automatically is used for the following purposes:</p>
	 <div>
	 	<li value="1"><span>Send notifications relating to events and event tasks..</span></li>
	 </div>
	 <br></br>
	 <div className={styles.blacktext}>
	 <h2>Who We Share Personal Data With</h2>
	 <h3>Employees</h3>
	 <p>We may disclose user data to any member of our organisation who reasonably needs access to user data to achieve the purposes set out in this Privacy Policy.</p>
	 <h3>Other Disclosures</h3>
	 <p>We will not sell or share your data with other third parties, except in the following cases:</p>
	 <div>
	 	<li value="1"><span>If the law requires it;</span></li>
	 	<li value="2"><span>If it is required for any legal proceeding;</span></li>
	 	<li value="3"><span>To prove or protect our legal rights; and</span>	</li>
	 	<li value="4"><span>To buyers or potential buyers of this company in the event that we seek to sell the company.</span></li>
	</div>
	<p>If you follow hyperlinks from our Site to another Site, please note that we are not responsible for and have no control over their privacy policies and practices.</p>
	<h2>How Long We Store Personal Data</h2>
	<p>User data will be stored until the purpose the data was collected for has been achieved.You will be notified if your data is kept for longer than this period.</p>
	<h2>How We Protect Your Personal Data</h2>
	<p>OAuth2. &nbsp;SSL. &nbsp;Robust security practices.While we take all reasonable precautions to ensure that user data is secure and that users are protected, there always remains the risk of harm. The Internet as a whole can be insecure at times and therefore we are unable to guarantee the security of user data beyond what is reasonably practical.</p>
	<h2>Your Rights as a User</h2>
	<p>Under the GDPR, you have the following rights:</p>
	<div>
		<li value="1"><span>Right to be informed;</span></li>
	 	<li value="2"><span>Right of access;</span></li>
	 	<li value="3"><span>Right to rectification;</span></li>
	 	<li value="4"><span>Right to erasure;</span></li>
	 	<li value="5"><span>Right to restrict processing;</span></li>
	 	<li value="6"><span>Right to data portability; and</span></li>
	 	<li value="7"><span>Right to object.</span></li>
	 </div>
	 <br></br>
	 <h2>Children</h2>
	 <p>We do not knowingly collect or use personal data from children under 16 years of age. If we learn that we have collected personal data from a child under 16 years of age, the personal data will be deleted as soon as possible. If a child under 16 years of age has provided us with personal data their parent or guardian may contact our data protection officer.</p>
	 <h2>How to Access, Modify, Delete, or Challenge the Data Collected</h2>
	 <p>If you would like to know if we have collected your personal data, how we have used your personal data, if we have disclosed your personal data and to who we disclosed your personal data, if you would like your data to be deleted or modified in any way, or if you would like to exercise any of your other rights under the GDPR, please contact our data protection officer here:</p>
	 <p>Matthew Bowen</p>
	 <p>customer-services@abs.uk.com</p>
	 <p>02476 939914</p>
	 <p>Unit 6, Centenary Business Centre, Nuneaton, CV11 6RY</p>
	 <h2>Modifications</h2>
	 <p>This Privacy Policy may be amended from time to time in order to maintain compliance with the law and to reflect any changes to our data collection process. When we amend this Privacy Policy we will update the "Effective Date" at the top of this Privacy Policy. We recommend that our users periodically review our Privacy Policy to ensure that they are notified of any updates. If necessary, we may notify users by email of changes to this Privacy Policy.</p>
	 <h2>Complaints</h2>
	 <p>If you have any complaints about how we process your personal data, please contact us through the contact methods listed in the <em>Contact Information</em> section so that we can, where possible, resolve the issue. If you feel we have not addressed your concern in a satisfactory manner you may contact a supervisory authority. You also have the right to directly make a complaint to a supervisory authority. You can lodge a complaint with a supervisory authority by contacting the Information Commissioner's Office in the UK.</p>
	 <h2>Contact Information</h2>
	 <p>If you have any questions, concerns or complaints, you can contact our data protection officer, Matthew Bowen, at:</p>
	 <p>customer-services@abs.uk.com</p>
	 <p>02476 939914</p>
	 <p>Unit 6, Centenary Business Centre, Nuneaton, CV11 6RY</p>
	 </div>
	</div>
	</Page>
    )
}